module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ijnAg"))).then(() => parcelRequire('hEqeo'));